// extracted by mini-css-extract-plugin
export default {"bar":"SearchInput_bar__ir2Vp","input":"SearchInput_input__6RsXE","actions":"SearchInput_actions__tbrn+","clear":"SearchInput_clear__lyxAS"};